import {
  SecondaryNavigationItemProps,
  SecondaryNavigationProps,
} from '@design-system/secondary-navigation';

import TMPLinkWrap from '~/components/TMPLinkWrap';
import { imageMapper } from '~/mappers/image';
import { linkMapper } from '~/mappers/link';

import { SecondaryNavigation, SecondaryNavigationItem } from './models';

export const secondaryNavigationItemMapper = ({
  link,
  subheading,
  image,
}: SecondaryNavigationItem): SecondaryNavigationItemProps => ({
  link: {
    ...{
      component: TMPLinkWrap,
      props: linkMapper({ ...link, variant: 'nav' }),
    },
  },
  subheading,
  ...(image?.length === 1 && {
    image: imageMapper(image[0], true),
  }),
});

export const secondaryNavigationMapper = ({
  mode,
  dropdown,
  items,
}: SecondaryNavigation): SecondaryNavigationProps => ({
  mode,
  isDropdown: dropdown?.setDropdown,
  dropdownButtonLabel: dropdown?.dropdownButtonLabel,
  items: items.map((item) => ({
    ...secondaryNavigationItemMapper(item),
  })),
  activeUrlPath:
    typeof window !== 'undefined'
      ? `${window.location.pathname}${window.location.hash.replace('/', '')}`
      : '',
});
